import type { EntityConfig } from '../types'

export const nativeTokenEntity: EntityConfig = {
  id: 'native-token',
  displayName: 'Native Token',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'revoked', label: 'Revoked' },
      { value: 'expired', label: 'Expired' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'suspended', label: 'Suspended', color: 'warning' },
      { value: 'revoked', label: 'Revoked', color: 'error' },
      { value: 'expired', label: 'Expired', color: 'neutral' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      inactive: ['inactive'],
      suspended: ['suspended'],
      revoked: ['revoked'],
      expired: ['expired'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['search', 'status', 'dateRange'],
}
